module.exports = __webpack_public_path__ + "static/img/report3d_img1.daf16525.png";